import ManageProfilesPage from './ManageProfilesPage'

export default ManageProfilesPage
// eslint-disable-next-line import/export
export * from './ManageProfilesPage'
